<app-page-shell variant="default">
  <div class="dashboard-welcome">
    <h1 class="dashboard-welcome__title">Welcome to Snöball</h1>
  </div>
</app-page-shell>
